import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import de from 'vuetify/src/locale/de'
import en from 'vuetify/src/locale/en'

Vue.use(Vuetify, {
  lang: {
    locales: { en, de },
    current: 'en',
  },
  theme: {
    primary: '#21398d',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  options: {
    customProperties: true
  },
  iconfont: 'md',
})
